import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * This route is used to handle the logout redirection. (landing on same page after logout)
 * It reads the `targetPage` query parameter from the URL and navigates to that page after logout.
 * If no `targetPage` is specified, it defaults to the home page.
 */
const StaticLogoutPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const targetPage = searchParams.get("targetPage");

    // If a target page is specified, navigate to it; otherwise, navigate to the home page,

    const safeTargetPage = targetPage?.startsWith("/")
      ? targetPage
      : `/${targetPage || ""}`;

    navigate(safeTargetPage, { replace: true });
  }, [navigate, searchParams]);

  return null;
};

export default StaticLogoutPage;
